//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, PoolTypeEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { IPoolBaseAbi, PoolFlexAbi } from '@shared/Abis'
import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'
import { UserConnection } from '@shared/DeploymentConfigs'

export const dailyInterestAccuralForFlexTx =
  (props: { poolAddr: EthAddr }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.DAILY_ACCRUAL_FLEX
    try {
      const { webSocket } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration
      const { roleEnum, signer } = getState().chainState.userConnection as UserConnection
      assertRole(roleEnum, RoleEnum.POOL_ADMIN)
      const { poolAddr } = props

      logOT.debug('dailyAccrualFlexSaga', poolAddr)
      await dailyInterestAccuralForFlex(webSocket, signer as Signer, poolAddr, chainConfigurationName)
      dispatch(poolActions.dailyAccrualFlexSuccess(props))
    } catch (e: any) {
      dispatch(poolActions.dailyAccrualFlexFail(props))
      await dispatchError(dispatch, e, activity, 1020)
    }
  }

export const dailyInterestAccuralForFlex = async (
  webSocket: WebSocket | undefined,
  poolAdminSigner: Signer,
  poolAddr: EthAddr,
  chainConfigurationName: string
): Promise<void> => {
  logOT.debug('dailyFlexAccrual ')

  const uuid = txUUID()
  webSocket?.send(wsServerActionPoolTXRequest(ActivityEnum.DAILY_ACCRUAL_FLEX, poolAddr, uuid, chainConfigurationName))

  const poolBaseContract = new Contract(poolAddr, IPoolBaseAbi, poolAdminSigner)
  const poolType = Number(await poolBaseContract.poolType())

  if (poolType === PoolTypeEnum.FlexibleRate) {
    const poolFlexContract = new Contract(poolAddr, PoolFlexAbi, poolAdminSigner)

    const tx2 = await poolFlexContract.dailyInterestAccural()

    webSocket?.send(
      wsServerActionPoolTX(ActivityEnum.DAILY_ACCRUAL_FLEX, poolAddr, uuid, tx2.hash as TxHash, chainConfigurationName)
    )

    await tx2.wait(1)
    logOT.debug('dailyInterestAccrual success', poolAddr)
  } else {
    throw new Error('Pool is not flexible rate')
  }
}
